import { useCallback } from 'react';

import {
  ActivityTrackerEventType,
  HomePageModuleNames,
  ModuleInteractionType,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentRoute } from '@/modules/activityTracker/useCurrentRoute';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useOutfitsUpsellTracking() {
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });
  const currentRoute = useCurrentRoute();

  const sendModuleView = useCallback(() => {
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_VIEW, {
      module: HomePageModuleNames.OutfitsUpsell,
      page: currentRoute,
    });
    sendActivityTrackerEvent(
      ActivityTrackerEventType.MODULE_INTERACTION_ACTION,
      {
        moduleName: HomePageModuleNames.OutfitsUpsell,
        interactionType: ModuleInteractionType.OutfitsUpsellView,
        schemaVersion: '1.0',
      }
    );
  }, [sendActivityTrackerEvent, currentRoute]);

  const sendCtaClick = useCallback(() => {
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, {
      moduleName: HomePageModuleNames.OutfitsUpsell,
      itemClicked: 'get_the_app_cta',
      itemPosition: 0,
      schemaVersion: '3.0',
    });
  }, [sendActivityTrackerEvent]);

  return { sendModuleView, sendCtaClick };
}
